export const personIdsForDesignInput = (people) =>
  (people || []).map((p) => p?.aggregateId).filter(Boolean);

const optionalDate = (dateValue) => dateValue || null;

export const buildDesignMutationInput = (input) => ({
  baselineWorkspaceId: input.baselineWorkspaceId,
  designWorkspaceId: input.designWorkspaceId || null,
  name: input.name,
  designType: input.designType,
  sponsorPersonIds: input.sponsors
    ? personIdsForDesignInput(input.sponsors)
    : undefined,
  leadPersonIds: input.leads ? personIdsForDesignInput(input.leads) : undefined,
  participantPersonIds: input.participants
    ? personIdsForDesignInput(input.participants)
    : undefined,
  scopeRootGroupIds: input.scopeRoots
    ? input.scopeRoots.map((r) => r.groupId)
    : input.scopeRootGroupIds,
  primaryDriver: input.primaryDriver,
  purpose: input.purpose,
  successCriteria: input.successCriteria,
  benefits: input.benefits,
  workflowStage: input.workflowStage,
  startDate: optionalDate(input.startDate),
  targetImplementationDate: optionalDate(input.targetImplementationDate),
  baselineDataDate: optionalDate(input.baselineDataDate),
});
